import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Products from './Products';
import Create from './Create/Create';
import View from './View/View'
import View2 from './AdminView/View2'
import CreatePayment from './Payment/CreatePayment'
import Receipt from './Payment/Receipt'

const ProductsRouter = () => (
    <BrowserRouter>
    <Switch>
      <Route exact path="/Products" component={Products} />
      {/*<Route exact path="/Products/Create" component={Create} />*/}
      <Route exact path="/Products/Create/:ID" component={Create} />
      {/* <Route path="/Products/View" component={View} /> */}
      <Route path="/products/view/:GUID" component={View} />
      <Route path="/products/adminview/:ID" component={View2} />
      <Route path="/products/Payment/CreatePayment" component={CreatePayment} />
      <Route path="/products/Payment/Receipt" component={Receipt} />
    </Switch>
  </BrowserRouter>
);

export default ProductsRouter